<template>
  <i
    :key="iconKey"
    :class="iconClass || ''"
    :data-fa-transform="transform || ''"
    @click="$emit('click', $event)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Required for making font awesome reactive
export default defineComponent({
  name: 'RsIconDisplay',
  props: { iconClass: String, iconKey: [Number, String], transform: String },
});
</script>
